var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"neto"},[(_vm.loading)?_c('md-progress-bar',{attrs:{"md-mode":"indeterminate"}}):_vm._e(),_c('div',{attrs:{"id":"netochart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }